import { Divider, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PageHeader from "../../components/UI/Headers/PageHeader/PageHeader";
import CustomTabs from "../../components/UI/Tabs/CustomTabs/CustomTabs";
import { TabItemEntity } from "../../entities/UIEntities/TabItem";
import { ROLES_HIERARCHY, TABLES } from "../../enums/Enums";
import useParkerService from "../../hooks/useParkerService";
import { userActions } from "../../redux/reducers/UserReducer";
import store from "../../redux/Store";
import { refreshAllUsersData, refreshSelectedUserExtendedData } from "../../services/ParkerService";
import Strings from "../../resources/Strings";
import ParkerInfo from "../UserInfo/SideWindowInfo/ParkerInfo";
import classes from "./ParkersPage.module.css";
import Icons from "../../resources/icons/Icons";
import { commonActions } from "../../redux/reducers/CommonReducer";
import AddParkerForm from "../../components/UI/Forms/Wizard Forms/AddForms/AddParkerForm";

const ParkersPage = () => {
  const parkers = useSelector((state) => state.user.parkers);
  const guests = useSelector((state) => state.user.guests);
  const currentUsersSite = useSelector((state) => state.user.currentUsersSite); 


  const gmtUser = useSelector((state) => state.user.gmtUser);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const [tableId, setTableId] = useState(TABLES.PARKERS); // 0
  let tabs = [];
  const showUserInfoWindow = useSelector((state) => {
    return state.user?.showUserInfoWindow;
  });
  
  let selectionModel = useSelector((state) => state.user.parkerSelectionModel); //useState(null);
  const { getParkersDataTable, getGuestsDataTable } = useParkerService();
  const onRowClick = (tableId, selectionModel) => {
    setTableId(tableId);
    const isNotEmptyModel = Object.keys(selectionModel).length !== 0;
    const userId = selectionModel?.utronUser?.id || selectionModel?.id;
    store.dispatch(userActions.setParkerSelectionModel(selectionModel));
    if (isNotEmptyModel) {                  
      // Fetch selected user data (extended data only)
      if (userId) {
        refreshSelectedUserExtendedData(userId).then(() => {
          store.dispatch(userActions.setShowUserInfoWindow(true));
        }).catch((error) => {
          store.dispatch(userActions.setShowUserInfoWindow(true));
        });
      }      
    }
  };
  
  const [parkersTab, setParkersTab] = useState(new TabItemEntity(
    Strings.TABS_NAMES.PERMANENT,
    TABLES.PARKERS,
    getParkersDataTable(onRowClick)
  ));

  const [guestsTab, setGuestsTab] = useState(new TabItemEntity(
    Strings.TABS_NAMES.GUESTS,
    TABLES.GUESTS,
    getGuestsDataTable(onRowClick)
  ));

  useEffect(() => {
    if (selectedScope?.id) {
      refreshAllUsersData();
    }
  }, []);

  useEffect(() => {
    setParkersTab(
      new TabItemEntity(
        Strings.TABS_NAMES.PERMANENT,
        TABLES.PARKERS,
        getParkersDataTable(onRowClick)
      )
    );

    setGuestsTab(
      new TabItemEntity(
        Strings.TABS_NAMES.PUBLIC_PARKERS,
        TABLES.GUESTS,
        getGuestsDataTable(onRowClick)
      )
    );

  },[parkers, guests]);

  tabs = [parkersTab, guestsTab];

  const handleCloseEvent = () => {
    store.dispatch(userActions.setShowUserInfoWindow(false));
  };

  const handleModalOpen = () => {
    store.dispatch(
      commonActions.setSideModal({ modalContent: <AddParkerForm /> })
    );
  };

  return (
    <div className={classes.parkersPage}>
      <Grid container spacing={4} className={classes.parkersContainer}>
        <Grid xs={12} item className={classes.item}>
          <PageHeader
            icon={Icons.PARKERS2}
            pageTitle={Strings.TITLES.PARKERS_PAGE}
            buttonText={Strings.ADD_NEW_PARKER}
            validRole={
              gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.COLLABORATOR
            }
            handleModalOpen={handleModalOpen}
          />
          {tabs && (
            <CustomTabs
              initialTab={Strings.TABS_NAMES.PERMANENT}
              tabs={tabs}
              onTabChange={handleCloseEvent}
            ></CustomTabs>
          )}
        </Grid>
        {showUserInfoWindow && selectionModel && (
          <Divider orientation="vertical" flexItem></Divider>
        )}
        {showUserInfoWindow && selectionModel && (
          <Grid xs={5} item className={classes.item}>
            <ParkerInfo
              {...selectionModel}
              handleCloseEvent={handleCloseEvent}
              tableId={tableId}
              gmtUser={gmtUser}
              validRole={
                gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.COLLABORATOR
              }
            ></ParkerInfo>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default ParkersPage;
